import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchCommunitydetail } from "../services/Communitydetail";
import { API_BASE } from "../api/apiConfig";

const Communitydetailcardbox = () => {
  const { id } = useParams();
  const [Communitydetaildata, setCommunitydetaildata] = useState(null);
  const [meetups, setMeetups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchCommunitydetail(decodeURIComponent(id));

      if (res?.data) {
         setCommunitydetaildata(res.data);
      }

      if (res?.upcoming_meetup?.length > 0) {
        setMeetups(res.upcoming_meetup);
      }

      setLoading(false);
    };

    loadBanner();
  }, [id]);

  if (loading) return <p className="text-center py-10">Loading...</p>;
  if (!Communitydetaildata) return <p className="text-center py-10">No Data found</p>;

  return (
    <>
     <section className="mb-6 md:mb-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {/* Community Members */}
          <div className="bg-white rounded-xl border border-slate-200 p-3 md:p-4 shadow-sm hover:shadow-md transition-all duration-300 hover:border-primary/30">
            <div className="flex items-center gap-2 mb-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-users h-4 w-4 md:h-5 md:w-5 text-primary"
              >
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
              <h3 className="text-base md:text-xl font-bold text-slate-800">{Communitydetaildata?.community_members}</h3>
            </div>
            <p className="text-xs md:text-sm text-slate-600">Community Members</p>
          </div>

          {/* Monthly Meetups */}
          <div className="bg-white rounded-xl border border-slate-200 p-3 md:p-4 shadow-sm hover:shadow-md transition-all duration-300 hover:border-primary/30">
            <div className="flex items-center gap-2 mb-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-calendar h-4 w-4 md:h-5 md:w-5 text-primary"
              >
                <path d="M8 2v4" />
                <path d="M16 2v4" />
                <rect width="18" height="18" x="3" y="4" rx="2" />
                <path d="M3 10h18" />
              </svg>
              <h3 className="text-base md:text-xl font-bold text-slate-800">{Communitydetaildata?.monthly_meetups}x</h3>
            </div>
            <p className="text-xs md:text-sm text-slate-600">Monthly Meetups</p>
          </div>

          {/* Year Founded */}
          <div className="bg-white rounded-xl border border-slate-200 p-3 md:p-4 shadow-sm hover:shadow-md transition-all duration-300 hover:border-primary/30">
            <div className="flex items-center gap-2 mb-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-map-pin h-4 w-4 md:h-5 md:w-5 text-primary"
              >
                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              <h3 className="text-base md:text-xl font-bold text-slate-800">{Communitydetaildata?.year_founded}</h3>
            </div>
            <p className="text-xs md:text-sm text-slate-600">Year Founded</p>
          </div>

          {/* Message Circle (Hidden on mobile) */}
          <div className="hidden md:block bg-white rounded-xl border border-slate-200 p-3 md:p-4 shadow-sm hover:shadow-md transition-all duration-300 hover:border-primary/30">
            <div className="flex items-center gap-2 mb-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-message-circle h-4 w-4 md:h-5 md:w-5 text-primary"
              >
                <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
              </svg>
              <h3 className="text-base md:text-xl font-bold text-slate-800">{Communitydetaildata?.active_member}</h3>
            </div>
            <p className="text-xs md:text-sm text-slate-600">Active Members</p>
          </div>
        </div>
      </section>


      <section className="mb-8 md:mb-12">
          <div className="flex items-center justify-between mb-4 md:mb-6">
            <h2 className="text-lg md:text-2xl font-bold text-slate-800">
              Upcoming Meetups in {Communitydetaildata.city}
            </h2>
            <a
              href="#"
              className="text-primary font-medium text-sm flex items-center hover:underline"
            >
              View Calendar
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-calendar ml-1 h-4 w-4"
              >
                <path d="M8 2v4" />
                <path d="M16 2v4" />
                <rect width="18" height="18" x="3" y="4" rx="2" />
                <path d="M3 10h18" />
              </svg>
            </a>
          </div>

          <div className="md:hidden space-y-4">
        {meetups.map((item, index) => (
            <div key={item.id} className="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
              <div className="relative h-36">
                <img
                  alt={item.heading}
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover"
                  style={{ position: 'absolute', height: '100%', width: '100%', inset: 0, color: 'transparent' }}
                  src={`${API_BASE}/${item.image}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                <div className="absolute top-3 left-3 bg-white rounded-lg px-2 py-1">
                  <p className="text-xs font-bold text-primary">{new Date(item.date).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                    })}</p>
                </div>
                {/*<div className="absolute top-3 right-3 bg-black/50 backdrop-blur-sm rounded-lg px-2 py-1">
                  <div className="flex items-center gap-1 text-white">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-users h-3 w-3"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <span className="text-xs font-medium">24</span>
                  </div>
                </div>*/}
                <div className="absolute bottom-3 left-3 right-3">
                  <h3 className="text-white font-bold text-sm mb-1 line-clamp-1">{item.heading}</h3>
                  <div className="flex items-center gap-3 text-xs text-white/90">
                    <div className="flex items-center gap-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-map-pin h-3 w-3"
                      >
                        <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                        <circle cx="12" cy="10" r="3" />
                      </svg>
                      <span className="truncate">{item.city}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-clock h-3 w-3"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="12 6 12 12 16 14" />
                      </svg>
                      <span>{item.time?.split("-")[0].trim()}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <p className="text-sm text-slate-600 mb-3 line-clamp-2" dangerouslySetInnerHTML={{ __html: item.about }}>
                </p>
                <button
                  className="inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 px-4 py-2 w-full bg-primary text-white hover:bg-primary/90 text-sm h-9"
                >
                  Join Event
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-arrow-right ml-1 h-3 w-3"
                  >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>
      ))}
          </div>



          <div className="hidden md:block">
            <div className="space-y-6">
              <div className="relative">
                {/* Timeline line */}
                <div className="absolute left-24 top-0 bottom-0 w-0.5 bg-primary/20"></div>
            
                {/* Event 1 */}
            {meetups.map((item, index) => (
                <div key={item.id} className="relative pl-32 pb-8">
                  {/* Timeline dot */}
                  <div className="absolute left-24 -translate-x-1/2 bg-white border-4 border-primary/20 rounded-full h-8 w-8 flex items-center justify-center z-10">
                    <div className="bg-primary rounded-full h-3 w-3"></div>
                  </div>
                  {/* Date & Time */}
                  <div className="absolute left-0 top-0 w-20 text-right">
                    <p className="font-medium text-primary">{new Date(item.date).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                    })}</p>
                    <p className="text-xs text-slate-500">{item.time?.split("-")[0].trim()}</p>
                  </div>
                  {/* Event Card */}
                  <div className="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 hover:border-primary/30">
                    <div className="flex">
                      {/* Image section */}
                      <div className="relative h-auto w-1/3 lg:w-1/4">
                        <img
                          alt={item.heading}
                          loading="lazy"
                          decoding="async"
                          data-nimg="fill"
                          className="object-cover"
                          style={{
                            position: 'absolute',
                            height: '100%',
                            width: '100%',
                            inset: 0,
                            color: 'transparent',
                          }}
                          src={`${API_BASE}/${item.image}`}
                        />
                      </div>
                      {/* Details section */}
                      <div className="p-6 w-2/3 lg:w-3/4">
                        <h3 className="text-lg font-bold text-slate-800 mb-2">{item.heading}</h3>
                        {/* Tags */}
                        <div className="flex flex-wrap gap-2 mb-3">
                          <div className="flex items-center gap-1.5 text-sm text-slate-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-map-pin h-4 w-4 text-primary"
                            >
                              <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                              <circle cx="12" cy="10" r="3"></circle>
                            </svg>
                            <span>{item.city}</span>
                          </div>
                          {/*<div className="flex items-center gap-1.5 text-sm text-slate-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-users h-4 w-4 text-primary"
                            >
                              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                              <circle cx="9" cy="7" r="4"></circle>
                              <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                            </svg>
                            <span>{item.heading}</span>
                          </div>*/}
                        </div>
                        {/* Description */}
                        <p className="text-sm text-slate-600 mb-4" dangerouslySetInnerHTML={{ __html: item.about }}>
                        </p>
                        {/* Attendees & Button */}
                        <div className="flex items-center justify-between">
                          {/* Attendees avatars */}
                          {/*<div className="flex -space-x-2">
                            <div className="h-8 w-8 rounded-full border-2 border-white bg-slate-200 flex items-center justify-center overflow-hidden">
                              <img
                                alt="Attendee"
                                loading="lazy"
                                width="32"
                                height="32"
                                decoding="async"
                                data-nimg="1"
                                className="object-cover"
                                style={{ color: 'transparent' }}
                                src="/assets/images/member-profile-1.png"
                              />
                            </div>
                            <div className="h-8 w-8 rounded-full border-2 border-white bg-slate-200 flex items-center justify-center overflow-hidden">
                              <img
                                alt="Attendee"
                                loading="lazy"
                                width="32"
                                height="32"
                                decoding="async"
                                data-nimg="1"
                                className="object-cover"
                                style={{ color: 'transparent' }}
                                src="/member-profile-2.jpg"
                              />
                            </div>
                            <div className="h-8 w-8 rounded-full border-2 border-white bg-slate-200 flex items-center justify-center overflow-hidden">
                              <img
                                alt="Attendee"
                                loading="lazy"
                                width="32"
                                height="32"
                                decoding="async"
                                data-nimg="1"
                                className="object-cover"
                                style={{ color: 'transparent' }}
                                src="/member-profile-3.jpg"
                              />
                            </div>
                            <div className="h-8 w-8 rounded-full border-2 border-white bg-slate-200 flex items-center justify-center overflow-hidden">
                              <img
                                alt="Attendee"
                                loading="lazy"
                                width="32"
                                height="32"
                                decoding="async"
                                data-nimg="1"
                                className="object-cover"
                                style={{ color: 'transparent' }}
                                src="/member-profile-4.jpg"
                              />
                            </div>
                            <div className="h-8 w-8 rounded-full border-2 border-white bg-primary/10 flex items-center justify-center text-xs font-medium text-primary">
                              +20
                            </div>
                          </div>*/}
                          {/* Join Button */}
                          <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 bg-primary text-white hover:bg-primary/90">
                            Join Event
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            ))}
                
              </div>
              {/* View All Meetup Button */}
              <div className="text-center pt-4">
                <a href="/meetups">
                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border hover:text-accent-foreground h-10 px-4 py-2 text-primary border-primary/30 hover:bg-primary/10 bg-transparent">
                    View All Meetups
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-chevron-right ml-1 h-4 w-4"
                    >
                      <path d="m9 18 6-6-6-6"></path>
                    </svg>
                  </button>
                </a>
              </div>
            </div>
          </div>
      </section>

    <section className="mb-6 md:mb-10">
      {/* Header with title and button */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg md:text-2xl font-bold text-slate-800">Featured Community Members</h2>
        <button
          className="inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 underline-offset-4 hover:underline h-10 text-primary text-sm p-0"
        >
          {/* Button Text */}
          View All Members
          {/* SVG icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-right ml-1 h-4 w-4"
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </button>
      </div>

      {/* Mobile View Members (visible on md:hidden) */}
       
       <div className="md:hidden bg-white rounded-xl border border-slate-200 p-4">
        <div className="grid grid-cols-3 gap-4">
          {/* Member Card */}
           {Communitydetaildata.local_experts_details?.length > 0 && Communitydetaildata.local_experts_details.map((member, index) => (
            <div key={member.id || index} className="text-center">
              <div className="relative mx-auto h-12 w-12 overflow-hidden rounded-full border-2 border-primary/20 mb-2">
                <img
                  alt={member.name}
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover"
                  style={{
                    position: 'absolute',
                    height: '100%',
                    width: '100%',
                    inset: 0,
                    color: 'transparent'
                  }}
                  src={
                  member.profile_image
                    ? `${API_BASE}/${member.profile_image}`
                    : "/images/default-avatar.png"
                }
                />
              </div>
              <p className="text-xs font-medium text-slate-800 truncate">{member.name}</p>
              <p className="text-xs text-primary truncate">{member.designation}</p>
            </div>
          ))}
        </div>
      </div>
      

      {/* Desktop View Members (hidden on mobile, grid on md) */}
      <div className="hidden md:grid grid-cols-6 gap-4">

       {Communitydetaildata.local_experts_details?.length > 0 && Communitydetaildata.local_experts_details.map((member, index) => (
          <div key={member.id || index} className="text-center group" data-state="closed">
            {/* Profile Image */}
            <div className="relative mx-auto h-16 w-16 md:h-20 md:w-20 overflow-hidden rounded-full border-2 border-primary/20 transition-all duration-300 group-hover:border-primary/50 group-hover:scale-105">
              <img
                alt={member.name}
                loading="lazy"
                decoding="async"
                data-nimg="fill"
                className="object-cover"
                style={{
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: 0,
                  color: 'transparent'
                }}
                src={
                  member.profile_image
                    ? `${API_BASE}/${member.profile_image}`
                    : "/images/default-avatar.png"
                }
              />
            </div>
            {/* Name and Role */}
            <p className="mt-2 text-sm font-medium text-slate-800">{member.name}</p>
            <p className="text-xs text-primary">{member.designation}</p>
          </div>
        ))}
      </div>

    </section>

   </>
  );
};

export default Communitydetailcardbox;
